module.exports = __webpack_public_path__ + "img/1581278.png";